import { assetUrl } from './hd-assets';
import { deferredAssetSource } from './asset-delivery';

/** Reuse packed URLs in native DOM/CSS as well as the canvas renderer. */
export function refreshPackedAssetBindings() {
  const replaceUrl = (url: string): string => {
    const deferred = deferredAssetSource(url);
    if (deferred) return assetUrl(deferred);
    if (!url || url.startsWith('blob:') || url.startsWith('data:')) return url;
    try {
      const parsed = new URL(url, location.href);
      return parsed.origin === location.origin && parsed.pathname.startsWith('/game/') ? assetUrl(parsed.pathname) : url;
    } catch { return url; }
  };
  const replaceStyle = (style: CSSStyleDeclaration) => {
    for (const name of Array.from(style)) {
      const old = style.getPropertyValue(name);
      const next = old.replace(/url\(["']?([^"')]+)["']?\)/g, (match, url) => {
        const packed = replaceUrl(url); return packed === url ? match : `url("${packed}")`;
      });
      if (next !== old) style.setProperty(name, next, style.getPropertyPriority(name));
    }
  };
  for (const image of document.querySelectorAll<HTMLImageElement>('img[src]')) {
    const old = image.getAttribute('src')!, next = replaceUrl(old);
    if (next !== old) image.src = next;
  }
  for (const element of document.querySelectorAll<HTMLElement>('[style]')) replaceStyle(element.style);
  const replaceRules = (rules: CSSRuleList) => {
    for (const rule of Array.from(rules)) {
      if ('style' in rule) replaceStyle((rule as CSSStyleRule).style);
      if ('cssRules' in rule) replaceRules((rule as CSSGroupingRule).cssRules);
    }
  };
  for (const sheet of Array.from(document.styleSheets)) {
    try { replaceRules(sheet.cssRules); } catch { /* Unrelated cross-origin extension sheets. */ }
  }
}
